import React from "react";
import CardBody from "./UTIVA_COMPS/CardBody";
import CardProps from "./UTIVA_COMPS/CardProps";
import Comp2 from "./UTIVA_COMPS/Comp2";
import Comp3 from "./UTIVA_COMPS/Comp3";
import Footer from "./UTIVA_COMPS/Footer";
import Utiva_Header from "./UTIVA_COMPS/Utiva_Header";
import Hero from "./UTIVA_COMPS/Hero";
import Comp1 from "./UTIVA_COMPS/Comp1";

const App = () => {
  return (
    <div>
      <Utiva_Header />
      <Hero />
      <br />
      <br />
      <br />
      <Comp2 />

      <br />
      <br />
      <Comp1 />
      <br />
      <br />
      <br />
      <br />
      <Comp3 />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <CardBody />
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default App;
